/* eslint-disable max-depth */
/* eslint-disable no-continue */
import React from 'react';
import { jsonLdScriptProps } from 'react-schemaorg';
import { FAQPage, Question, Answer } from 'schema-dts';
import Head from 'next/head';
import { markdownToPlainText } from 'components/Atoms/RenderMarkdownMarked/RenderMarkdownMarked';
import { PageType } from 'types/publishedAssets';
import { useGetContentTranslations } from 'utils/useGetContentTranslations';

interface PageProps {
  page: PageType;
}

export function FaqStructuredData(props: PageProps): JSX.Element | null {
  const { page } = props;
  const { translate } = useGetContentTranslations();

  const mainEntity: Question[] = [];

  for (let sectionIt = 0; sectionIt < page?.sections?.length; sectionIt++) {
    const section = page?.sections?.[sectionIt];
    for (let entityIt = 0; entityIt < section?.section_entities?.length; entityIt++) {
      const entity = section?.section_entities?.[entityIt];
      if (!entity) continue;
      if (entity.content_type !== 'accordion') continue;
      const faqEnabled = (entity.metadata as { faq_structured_data_enabled?: boolean })?.faq_structured_data_enabled;
      if (!faqEnabled) continue;
      for (let componentIt = 0; componentIt < entity?.components?.length; componentIt++) {
        const component = entity?.components?.[componentIt];
        if (!component) continue;
        if (component.content_component_type !== 'accordion_item') continue;
        const name = translate(component.translations, 'title');
        const rawContent = translate(component.translations, 'description');
        if (!name?.trim()) continue;
        const acceptedAnswer: Answer = {
          '@type': 'Answer',
          text: markdownToPlainText(rawContent ?? '') || '',
        };
        mainEntity.push({
          '@type': 'Question',
          name: name.trim(),
          acceptedAnswer,
        });
      }
    }
  }

  if (mainEntity.length === 0) {
    return null;
  }

  const structuredData = jsonLdScriptProps<FAQPage>({
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity,
  });

  return (
    <Head>
      <script
        key="structured-data-faq"
        type="application/ld+json"
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...structuredData}
      />
    </Head>
  );
}
